import { Controller } from "@hotwired/stimulus";
import { setCookie, getCookie } from "./cookies";

const EVENT_COOKIE_NAME = "dispatch-event";

export default class extends Controller {
    static values = {
        eventOnConnect: String,
        delayTo: String,
        eventFromCookie: Boolean,
        eventIfExistsInCookie: String,
        ifNotHidden: Boolean,
        detail: Object,
    };

    getEventCookie() {
        return getCookie(EVENT_COOKIE_NAME);
    }

    setEventCookie(value, attributes = {}) {
        return setCookie(EVENT_COOKIE_NAME, value, attributes);
    }

    _dispatchEvent(eventStr) {
        const parts = eventStr.split("@");
        let target = "";
        if (parts.length > 1) {
            target = parts[1];
        }
        const name = parts[0];
        const event = this.detailValue ? new CustomEvent(name, { detail: this.detailValue }) : new Event(name);
        if (target === "window") {
            dispatchEvent(event);
        } else if (target === "document") {
            document.dispatchEvent(event);
        } else if (target === "element") {
            this.element.dispatchEvent(event);
        } else {
            dispatchEvent(event);
        }
    }

    delayOrDispatchEvent(event) {
        if (this.hasDelayToValue) {
            addEventListener(
                this.delayToValue,
                () => {
                    this._dispatchEvent(event);
                    this.setEventCookie("", { path: "/", "max-age": "-1" });
                },
                { once: true },
            );
        } else {
            this._dispatchEvent(event);
            this.setEventCookie("", { path: "/", "max-age": "-1" });
        }
    }

    connect() {
        if (!this.hasEventOnConnectValue && !this.hasEventFromCookieValue && !this.hasEventIfExistsInCookieValue) {
            return;
        }
        if (this.ifNotHiddenValue) {
            const style = window.getComputedStyle(this.element);
            if (style.display === "none") {
                return;
            }
        }
        if (this.hasEventOnConnectValue) {
            const event = this.eventOnConnectValue;
            if (!event) {
                return;
            }
            this.delayOrDispatchEvent(event);
        } else if (this.hasEventFromCookieValue) {
            const [event, found] = getCookie(EVENT_COOKIE_NAME);
            if (!found) {
                return;
            }
            this.delayOrDispatchEvent(event);
        } else if (this.eventIfExistsInCookieValue !== "") {
            const [event, found] = getCookie(EVENT_COOKIE_NAME);
            if (!found) {
                return;
            }
            if (this.eventIfExistsInCookieValue !== event) {
                return;
            }
            this.delayOrDispatchEvent(event);
        }
    }

    event({ params }) {
        if (!params.event) {
            return;
        }
        const event = params.event;
        if (!event) {
            return;
        }
        this._dispatchEvent(event);
    }
}
